import * as $ from "jquery";

export type dxKnockoutPopupOptions = DevExpress.ui.dxPopupOptions & { visible: KnockoutObservable<boolean> } 
    & { wrapper: string, onEnterKeyDown: () => any };

export class Popup {
    
    private instance: DevExpress.ui.dxPopup | undefined;
    
    constructor(public config: dxKnockoutPopupOptions) {
        
        config.onInitialized = (e) => {
            this.instance = e.component;
        };

        config.visible.subscribe(visible => {
            if (!config.wrapper)
                return;
            
            let wrapperDiv = $(config.wrapper);

            if(!visible) {
                wrapperDiv.off("keydown");
                return;
            }

            wrapperDiv.on("keydown", (e:any) => {
                if(e.keyCode === 13 && config.onEnterKeyDown) {
                    let focused = $(':focus');
                    if (focused) focused.blur();
                    config.onEnterKeyDown();
                }
                if(e.keyCode === 27) {
                    config.visible(false);
                }
            });
        });
    }
    
    setTitle(title: string) {
        console.log('setting title', title, this.instance);
        if(!this.instance)
            return;

        this.instance.option("title", title);
    }

    autoSize() {
        if (!this.instance)
            return;

        this.instance.option("height", "auto");
        this.instance.option("width", "auto");
    }
    
    setHeight(val: number) {
        if(!this.instance)
            return;
        
        this.instance.option("height", val);
    }

    setWidth(val: number) {
        if(!this.instance)
            return;

        this.instance.option("width", val);
    }

    close() {
        if (!this.instance)
            return;

        this.instance.hide();
    }

    getElement() {
        if (!this.instance)
            return;

        return  this.instance.element();
    }

    repaint() {
        if (!this.instance)
            return;

        return  this.instance.repaint();
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/common/popup-helper.ts